import { pushEvent } from "@/lib/datalayer";
import { supabase } from "@/integrations/supabase/client";

const STORAGE_KEY = "sp_visitor_id";

function getOrCreateVisitorId(): string {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

/** Push user_id to dataLayer — auth id when logged in, persistent visitor id otherwise. */
export function initUserId() {
  const visitorId = getOrCreateVisitorId();

  // Push immediately for anonymous visitors
  pushEvent("set_user_id", { user_id: visitorId });

  // Override with auth id when session exists / changes
  const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
    pushEvent("set_user_id", {
      user_id: session?.user?.id ?? visitorId,
    });
  });

  return () => subscription.unsubscribe();
}
